import React, { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Oval } from "react-loader-spinner"; // Import loader
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons"; // Import eye icons
import { StandardURL } from "../App";


const Login = () => {
  const navigate = useNavigate();

  const [isLoading, setIsLoading] = useState(false); // Add loading state
  const [passwordVisible, setPasswordVisible] = useState(false); // State for toggling password visibility

  const [formData, setFormData] = useState({
    email: "",
    password: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const togglePasswordVisibility = () => {
    setPasswordVisible(!passwordVisible);
  };

  const handleSubmit = async (e) => {
    setIsLoading(true); // Set loading state to true
    e.preventDefault();
    try {
      const response = await axios.post(
        `${StandardURL}/iNyumba/auth/login`,
        formData
      );

      localStorage.setItem("token", response.data.response);
      toast.success("Please check your email for OTP!");

      navigate("/OtpVerification");
    } catch (error) {
      console.error(error);
      setIsLoading(false); // Set loading state to false
      if (error.response && error.response.status === 401) {
        toast.error("Unauthorized access.");
      } else if (error.response && error.response.status === 406) {
        toast.error("Please enter the correct email and password.");
      } else if (error.response && error.response.status === 400) {
        toast.error("Your password has expired. Please reset your password.");
      } else {
        toast.error("An error occurred, please try again later.");
      }
    }
  };

return (
  <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-indigo-50 to-blue-100 py-12 px-4 sm:px-6 lg:px-8">
    <div className="max-w-md w-full bg-white p-8 rounded-2xl shadow-2xl border border-gray-200 transform hover:scale-105 transition-all duration-300 ease-in-out">
      <div className="text-center">
        <h2 className="mt-2 text-4xl font-extrabold text-gray-900 leading-tight">
          Welcome Back! 👋
        </h2>
        <p className="mt-2 text-sm text-gray-600">
          Sign in to access your account.
        </p>
      </div>
      <form className="mt-8 space-y-6" onSubmit={handleSubmit}>
        <div className="space-y-4">
          <div>
            <label htmlFor="email" className="sr-only">
              Email address
            </label>
            <input
              id="email"
              name="email"
              type="email"
              autoComplete="email"
              required
              className="mt-1 block w-full px-4 py-2 border border-gray-300 rounded-lg shadow-sm placeholder-gray-400 text-gray-900 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 sm:text-base transition duration-200 ease-in-out"
              placeholder="Your email address"
              value={formData.email}
              onChange={handleChange}
            />
          </div>
          <div className="relative">
            <label htmlFor="password" className="sr-only">
              Password
            </label>
            <input
              id="password"
              name="password"
              type={passwordVisible ? "text" : "password"}
              autoComplete="current-password"
              required
              className="mt-1 block w-full px-4 py-2 border border-gray-300 rounded-lg shadow-sm placeholder-gray-400 text-gray-900 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 sm:text-base pr-10 transition duration-200 ease-in-out"
              placeholder="Your password"
              value={formData.password}
              onChange={handleChange}
            />
            <button
              type="button"
              onClick={togglePasswordVisibility}
              className="absolute inset-y-0 right-0 pr-3 flex items-center text-gray-500 hover:text-gray-700 focus:outline-none transition duration-200"
              aria-label={passwordVisible ? "Hide password" : "Show password"}
            >
              <FontAwesomeIcon icon={passwordVisible ? faEye : faEyeSlash} className="h-5 w-5" />
            </button>
          </div>
        </div>

        <div className="flex items-center justify-end text-sm mt-4">
          <a
            href="/forgot-password"
            className="font-medium text-indigo-600 hover:text-indigo-500 transition-colors duration-200"
          >
            Forgot your password?
          </a>
        </div>

        <div>
          <button
            type="submit"
            disabled={isLoading}
            className={`
              relative w-full flex justify-center py-2.5 px-4 border border-transparent text-lg font-semibold rounded-lg shadow-md
              ${isLoading
                ? "bg-indigo-400 cursor-not-allowed"
                : "bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 transform transition-all duration-200 ease-in-out hover:scale-105"
              }
              text-white
            `}
          >
            {isLoading ? (
              <Oval
                height={24}
                width={24}
                color="white"
                visible={true}
                ariaLabel='oval-loading'
                secondaryColor="rgba(255,255,255,0.4)"
                strokeWidth={5}
                strokeWidthSecondary={5}
              />
            ) : (
              "Sign In"
            )}
          </button>
        </div>

        <div className="text-sm text-center mt-6 text-gray-600">
          Don't have an account?{" "}
          <a
            href="/registration"
            className="font-semibold text-indigo-600 hover:text-indigo-500 transition-colors duration-200"
          >
            Sign up now!
          </a>
        </div>
      </form>
    </div>
  </div>
);
};

export default Login;